module.exports = __webpack_public_path__ + "static/media/james.63f0f0d2.jpg";